module.exports = __webpack_public_path__ + "img/bird01.8b7b6701.png";